import { render, staticRenderFns } from "./global-video-screen-recording.vue?vue&type=template&id=5ab65947"
import script from "./global-video-screen-recording.vue?vue&type=script&lang=js"
export * from "./global-video-screen-recording.vue?vue&type=script&lang=js"
import style0 from "./global-video-screen-recording.vue?vue&type=style&index=0&id=5ab65947&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports